<script>
    import { flow_steps, dbClearAllInvalidItems, clearAllInvalidItems, invalidateItem,user_data, parseCityStateZip, userNotification, countyChecker, checkZip , updatePropertyZipInfo} from '../stores.js';
    import * as yup from 'yup'; 
    import { debounce } from 'lodash';
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    import CTA from './ctacomponent.svelte';
    import FooterComponent from './footercomponent.svelte';
    import Chipscompnent from './chipscompnent.svelte';


   
    export let progress_mobile_version = false;
    let mobile_menu_open = "";
    let show_dropdown = false;
    let show_searching_indicator = true;
    export let top_container_background = true;

    // let current_address;

    // function doPlaceChanged(evt){
    //     console.log("... doing placechange")
    //     console.log(evt);
    // }

    function toggleMobileMenu(){
        if(mobile_menu_open === "open"){
            mobile_menu_open = "";
        }else{
            mobile_menu_open = "open";
        }
    }

    let dropdown_shown = "";
    function toggleLinkList(ds){
        closeLinkList();
        if(ds === "") {
            dropdown_shown = "shown";
        }else{
            dropdown_shown = "";
        }
    }
    function closeLinkList(){
        if(dropdown_shown === "shown") {
            dropdown_shown = "";
        }
        if(resource_dropdown_shown === "shown") {
            resource_dropdown_shown = "";
        }
        if(services_dropdown_shown === "shown") {
            services_dropdown_shown = "";
        }
    }

    let resource_dropdown_shown = "";
    function toggleResourceLinkList(rds){
        closeLinkList();
        if(rds === "") {
            resource_dropdown_shown = "shown";
        }else{
            resource_dropdown_shown = "";
        }
    }

    let services_dropdown_shown = "";
    function toggleServicesLinkList(sds){
        closeLinkList();
        if(sds === "") {
            services_dropdown_shown = "shown";
        }else{
            services_dropdown_shown = "";
        }
    }

    const formSchema = yup.object().shape({
        csv: yup
            .string()
            .required('Zip code or City,State is required to find the best rates.'),
    });

    let csz_element;
    let error_label_element;
    let csz_error = "";
    let dropdown_element;
    async function doGetStarted(auto_submit=false) {

        // if(csz_error !== ""){
            if (typeof gtag !== "undefined"){
            // gtag('event', 'get_todays_rates', {
                // 'event_category': 'button_click',
                // 'event_label': 'Rate Table Site'
            // });
        }

        console.log(`doGetstarted value ${csz_value}`);
        // $user_data.propertyaddress = csz_value.address;
        // $user_data.propertycity = csz_value.city;
        // $user_data.propertystate = csz_value.state;
        // $user_data.propertyzipcode = csz_value.zipcode;
        // $user_data.propertycounty = csz_value.county;
        show_dropdown = false;
        clearAllInvalidItems();
        // testing county checker
        // countyChecker();
        updatePropertyZipInfo(csz_value);
        push("#/iq?p=0"); 

        // }

//         if(auto_submit){
//             push("#/iq?p=0"); 
//         }else{
//                 formSchema.validate({ csv: csz_element.value.trim() }).then(async function (value) {
//                 // console.log(`success`);
//                 // console.log(value);
//                 const tres = await searchCSZ(csz_element.value.trim());
// console.log(tres);
//                 if(tres !== undefined && tres.length === 1){
//                     selectDropdownItem(tres[0].zip_code, tres[0].city, tres[0].state, tres[0].county);
//                     // push("#/iq"); 
//                 }else{
//                     userNotification("error", "Error:", "Exact city, state, or zip not found. Please review and try again or select an option from the dropdown.");
//                 }

//             }).catch(function (err) {
//                 invalidateItem(csz_element, err.errors[0]);
//                 console.log(err.name);
//                 console.log(err.errors);
//             // err.name; // => 'ValidationError'
//             // err.errors; // => ['age must be a number']
//             });

//         }

    }

    async function searchCSZ(auto_submit){
        drop_down_items = [];
        dropdown_element.style.top = `${csz_element.offsetHeight}px`;
        show_dropdown = true;
        
        return new Promise(async (resolve, reject) => {
            await superagent
            .post('/api/obapi')
            .send({ action: 'search_zipcode', search_data: csz_element.value }) // sends a JSON post body
            .set('accept', 'json')
            .end((err, res) => {
    // console.log(err);
    // console.log(res);
                if(err !== null){
                    userNotification('error', 'Error:', err.toString());
                        reject(undefined);
                }else{
                    const jres = JSON.parse(res.text);
    // console.log(jres);
                    if(jres.st){
                        // let height = box.offsetHeight;
                        // element.style.width = "100px";
                        drop_down_items = jres.data;
                        if(drop_down_items.length > 0){
                            show_dropdown = true;
                        }else{
                            show_dropdown = false;
                        } 
                        resolve(jres.data);
                        // return tres.resolve(jres.data);
                        // return jres.data;
                    }else{
                        userNotification('error', 'Error:', res.msg);
                        reject(undefined);
                    }
                }
            });
        });
        // let promise = new Promise(function(resolve, reject) {
  // the function is executed automatically when the promise is constructed

  // after 1 second signal that the job is done with the result "done"
//   setTimeout(() => resolve("done"), 1000);
// });

        // return tres;
    }

    function selectDropdownItem(zc, ctty, st, cnty){

        $user_data.propertyzipcode = zc;
        $user_data.propertycity = ctty;
        $user_data.propertystate = st;
        $user_data.propertycounty = cnty;
        csz_value = `${ctty}, ${st} (${zc})`;
        show_dropdown = false;
        doGetStarted(true);
    }

    let drop_down_items = [];
    let debouncedDisplayDropdownMatches = debounce(function() {
//         drop_down_items = [];
//         dropdown_element.style.top = `${csz_element.offsetHeight}px`;
//         // let height = box.offsetHeight;
//         // element.style.width = "100px";
        searchCSZ();
// console.log(drop_down_items);
//         if(drop_down_items.length > 0) show_dropdown = true;

    }, 200);

//     async function displayDropdownMatches(){
//         drop_down_items = [];
//         dropdown_element.style.top = `${csz_element.offsetHeight}px`;
//         // let height = box.offsetHeight;
//         // element.style.width = "100px";
//         drop_down_items = await searchCSZ();
// console.log(drop_down_items);
//         if(drop_down_items.length > 0) show_dropdown = true;
//     }

    function cszError(the_error){
        csz_error = "csz_error";
    }
    function clearCSZError(){
        csz_error = "";
    }

    function doKeyUp2(evt){
        dbClearAllInvalidItems();
        if(evt.keyCode === 13 && csz_error !== "csz_error" && evt.target.value.trim().length !== 0){
            doGetStarted();
        }else{
            if(evt.target.value.trim().length !== 0){
                const is_good = checkZip(evt.target.value.trim());
                // console.log(is_good);
                if(is_good){
                    // dbClearAllInvalidItems(); 
                    clearCSZError();
                }else{
                    // invalidateItem(csz_element, "Please enter a valid zip code");
                    cszError();
                }

            }else{
                clearCSZError();
            }
        }

    
    }

    let csz_value = "";
    function doKeyUp(evt) {
        dbClearAllInvalidItems();

        // console.log(evt);
        if(evt.keyCode === 13){
            doGetStarted();
        }else{
            if(evt.target.value.trim().length === 0){
                show_dropdown = false;
            }
            if(evt.target.value.length >= 3){
                debouncedDisplayDropdownMatches();
            }
            const tdata = parseCityStateZip(evt.target.value);
            // console.log(tdata);
            if(tdata.st){
                if(tdata.type === "zip") $user_data.propertyzipcode = tdata.value[0];

                if(tdata.type === "cs") {
                    $user_data.propertycity = tdata.value[0];
                    $user_data.propertystate = tdata.value[1];                   
                }
            }

        }

    }

</script>


<div class="maincontainer  {(progress_mobile_version) ? "maincontainerprogressmobile" : "" }">

    <div on:click|self={()=>{closeLinkList();}} class="topcontainer {(top_container_background) ? "" : "notopcontainerbackground" }">
        <div class="navmobilecontainer {(progress_mobile_version) ? "navmobilecontainerprogressmobile" : "" }">
            <div class="logocontainer"><a href="/"><img src="{(top_container_background) ? "/img/semper elevate_white.svg" : "/img/semper elevate_dark.svg"}" alt="Semper Home Loans Logo"></a></div>
        </div>

        <div  on:click|self={()=>{closeLinkList();}} class="navcontainer">
            <div class="logocontainer"><a href="/"><img src="{(top_container_background) ? "/img/semper elevate_white.svg" : "/img/semper elevate_dark.svg"}" alt="Semper Home Loans Logo"></a></div>


        </div>
        <div class="stepcontainer {(progress_mobile_version) ? "stepcontainerprogressmobile" : "" }">
            <slot>
                <div class="cszinputcontainer">
                    <div class="csztitlecontainer">Take this 3 minute quiz
                        to see if you qualify</div>
                    <div class="cszinputfieldcontainer">
                        <div class="progresstext">1/6</div>
                        <div class="csztopcopy">
                            What type of home are you looking for?
                        </div>
                        <Chipscompnent
                        chipsdata={ [
                            {s: true, t: "Single Family", i:"/img/House.svg", cbf:()=>{$user_data.propertytype = "SingleFamily"}, n: "#/loan_amount"},
                            {s: false, t: "Condo", i:"/img/Condo.svg", cbf:()=>{$user_data.propertytype = "Condo"}, n: "#/loan_amount"},
                            {s: false, t: "Multi-unit", i:"/img/Multi-Unit.svg", cbf:()=>{$user_data.propertytype = "Multi-unit"}, n: "#/loan_amount"},
                        ] }
                        />

                        <div class="progressbuttonholder">
                            <button on:click={()=>{push("#/loan_amount");}} class="darken">Next</button>
                        </div>

                    </div>
                </div>
    
            </slot>
            <!-- {#if step_info === "landing"} -->
            
            <!-- {:else} -->
            <!-- {/if} -->
        </div>
    </div>



    <div class="seehoweasycontainer">

        <div class="asseenon">
            <div class="asotitle shetitle">As seen on:</div>
            <div class="asologocontainer">
                <div class="asoimagecontainer">
                    <img src="/img/logo_forbes.png" alt="forbes">
                </div>
                <div class="asoimagecontainer">
                    <img src="/img/logo_realtorcom.png" alt="realtor.com">
                </div>
                <div class="asoimagecontainer">
                    <img src="/img/logo_msn.png" alt="msn">
                </div>
                <div class="asoimagecontainer">
                    <img src="/img/logo_mf.png" alt="motley fool">
                </div>
                <div class="asoimagecontainer">
                    <img src="/img/logo_bankrate.png" alt="bankerate">
                </div>
                </div>
        </div>

    </div>

    <div class="footercontainer">
        <FooterComponent />
    </div>

    <div class="mobileholder">Would be switching to mobile layout here.</div>

</div>
<style>
.maincontainer {
    width: 100%;
    /* padding: 10px; */
    margin-left: auto;
    margin-right: auto;
    /* margin-top: 20px; */
    /* background-color: white; */
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    grid-template-areas: "tc tc tc tc tc tc tc tc tc tc tc tc"
                         "bc bc bc bc bc bc bc bc bc bc bc bc"
                         "sc sc sc sc sc sc sc sc sc sc sc sc"
                         "fc fc fc fc fc fc fc fc fc fc fc fc";
    gap: 20px;

}

.topcontainer {
    grid-area: tc;
    background-image: url(/img/House_1_opacity.png);
    background-repeat:no-repeat;
    /* min-height: 700px; */
    /* max-height: 700px; */
    /* height: 52vw; */
    width: 100vw;
    background-position: 0% 0%;
    background-size: 100% 100%;
    padding-bottom: 80px !important;
}    
.topcontainer.notopcontainerbackground {
    background: none !important;
}

.navmobilecontainer {
    display: none;
}
.navcontainer {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.logocontainer img {
    height: 36px;
}
.navlinkscontainer {
    display: flex;
    flex-direction: row;
    margin-left: 73.1484px;
}

.navlink a:hover, .navlink a:focus {
    /* font-weight: bold; */
    /* padding-left: 10px; */
    /* padding-right: 10px; */
    /* padding-top: 10px; */
    /* padding-bottom: 10px; */
    /* font-weight:700; */
    /* font-size: 1em; */
    /* color: var(--darkgray); */
    /* background-color: transparent; */
    /* border: solid 1.75px; */
    /* border-color: white; */
    /* border-radius: 5px; */
    cursor: pointer;   
    text-decoration: underline;
    /* transition: all 100ms ease-in-out;  */
}

.navlink a{
    color: white;
    font-size: 1em;
    font-weight: 500;
    text-decoration: none;
    margin-left: 25px;
    transition: all 500ms linear; 
}

.rightnavcontainer {
    display: flex;
    align-items: center;
}

.navbuttoncontainer {
    margin-left: 20px;
}

.navbuttoncontainer button{
    display: inline-block;
    /* line-height: 50px; */
    text-align: center;
    vertical-align: middle;
    /* height: 64px; */
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 15px;
    padding-bottom: 15px;
    font-weight:700;
    font-size: 1em;
    /* color: var(--darkgray); */
    color: white;
    background-color: transparent;
    border-style: solid;
    border-width: 1.75px;
    border-color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.25s linear;
    box-sizing: border-box;

}

.navbuttoncontainer button:hover {
    /* border-color: var(--semperred); */
    /* color: white; */
    /* background-color: var(--semperred); */
    border-width: 2px;
    /* font-weight: 900; */
    transition: all 0.25s linear;
}

.viewrateslinkcontainer {
    position: relative;
}
.viewrateslink:hover, .viewrateslink:link, .viewrateslink:active {
    text-decoration: none !important;
}
.viewrateslink::after {
    display: inline-block;
    content: ' ';
    background-image: url('/img/Down_arrow_white-01.svg');
    background-size: 10px 10px;
    height: 10px;
    width: 10px;    
    /* content: '\2228'; */
    color: #ebebec !important;
    margin-left: 5px;
    transition: all 0.5s linear;
}
/* [class="viewrateslink shown"]:after { 
    content: '\2227';
    color: white;
    margin-left: 3px;
}
[class="shown viewrateslink"]:after { 
    content: '\2227';
    color: white;
    margin-left: 3px;
} */
.viewrateslink.shown::after {
    /* content: '\2227';
    color: #ebebec !important;
    margin-left: 5px; */
    transform: rotate(-180deg);
}

.dropdown-content {
    /* display: none; */
    visibility: hidden;
    opacity: 0;
    position: absolute;
    background-color: white;
    min-width: 250px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
    border-radius: 5px;
    margin-top: 20px;
    padding: 5px;
    box-sizing: border-box;
    transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
}
.dropdown-content.shown {
    /* display: block; */
    visibility: visible;
    opacity: 1;
    /* transform: translate(0, -20px); */
    /* transform: translate(-50%, 25px); */
    transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);

}
.dclinkcontainer {
    /* padding-top: 20px; */
    /* padding-bottom: 20px; */
    width: 100%;
}
/* .dclinkcontainer:hover {
    background-color: #ebebec;
    cursor: pointer;
} */
.dclinkcontainer button {
    width: 100%;
    height: 100%;
    border: none;
    text-align: left !important;
    background-color: white;
    color: #343d50 !important;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    cursor: pointer;
}
.dclinkcontainer button:hover {
    background-color: #ebebec;

}
/* .dropdown-content a{
    color: #343d50 !important;
    width: 100%;
    height: 100%;
}
.dropdown-content a:link {
  text-decoration: none;
}

.dropdown-content a:visited {
  text-decoration: none;
}

.dropdown-content a:hover {
  text-decoration: none;
  background-color: #ebebec;
}

.dropdown-content a:active {
  text-decoration: none;
} */

.stepcontainer {
    width: 75%;
    /* height: 200px; */
    margin-left: auto;
    margin-right: auto;
    /* margin-top: 80px; */
    /* background-color: white; */
}
.cbcheadphones {
    width: 20px;
    height: 20px;
    margin-right: 20px;
}
.cbcheadphones img {
    width: 100%;
    height: 100%;
}
.cszbottomcopy a {
    color: #657680 !important;
    margin-left: 5px;
}
.cszfieldcontainer {
    width: 100%;
    /* margin-left: auto; */
    /* margin-right: auto; */
    padding: 0px;
    display: flex;
    position: relative;
    flex-direction: row;
    /* justify-content: center; */
    align-items: center;
    margin-top: 25px;
}
/* .fieldsearchbusy {
    z-index: 999;
    position: absolute;
    top: 0px;
    width: 24px;
    height: 24px;
}
.fieldsearchbusy img {
    width: 100%;
    height: 100%;
} */
.searchingplaceholder {
    width: 100%;
    padding: 0px;
    display: flex;
}
.searchingplaceholdertext {
    color: var(--semperred);
    font-weight: bold;
    font-size: 1em;
}
.searchingplaceholderindicator {
    width: 100%;
    display: flex;
    justify-content: center;
}
.searchingplaceholderindicator img{
    width: 25%;
}
.dropdownsearchcontainer {
    z-index: 999;
    position: absolute;
    top: 50px;
    margin-left: auto;
    margin-right: auto;
    /* display: flex; */
    /* flex-direction: column; */
    width: 300px;
    max-height: 150px;
    background-color: white;
    overflow-y: scroll;
    box-sizing: border-box;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: 1px solid;
    border-bottom: 1px solid;
    border-right: 1px solid;
    border-color: var(--placeholdergray);
    
}
.dropdownsearchcontainer button {
    border: none;
    border-radius: 0px !important;
    /* border-bottom-right-radius: 0px !important; */
    background-color: white !important;
    color: var(--placeholdergray) !important;
    height: 40px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-align: left !important;
    margin-left: 0px !important;
 
}
.dropdownsearchcontainer button:hover {
    color: white !important;
    background-color: var(--placeholdergray) !important;
}
.dropdownsearchcontainer button:not(:last-of-type) {
    border-bottom: 1px solid #ccc;
}

.cszfieldcontainer button {
    height: 50px;
    box-sizing: border-box;
    background-color: var(--semperred);
    border: none;
    color: white;
    font-weight: 600;
    padding: 20px 40px;
    border-radius: 5px;
    cursor:pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 16px;
    transition: all 0.25s linear;
}
:global(.floatingplaceholder){
    -webkit-appearance: none;
    border-radius: 5px;
    height: 50px;
    /* border-bottom-right-radius: 0px; */
    /* border-top-right-radius: 0px; */
    min-width: 300px;
    box-sizing: border-box;
    border-color: #747b84;
    border-width: 1px;
    padding-left: 10px;
    padding-top: 10px;
    
}
/* :global(.floatingplaceholder:focus ~ .floating-label,
.floatingplaceholder:not(:focus):valid ~ .floating-label){
  top: 4px;
  bottom: 10px;
  left: 10px;
  font-size: 11px;
  opacity: 0;
} */
.floating-label2 {
  position: absolute;
  pointer-events: none;
  left: 10px;
  top: 4px;
  font-size: 11px;
  transition: 0.2s ease all;
  color: var(--semperred);
  opacity: 0 !important;
}
.floating-label2.csz_error {
    opacity: 1 !important;
    transition: 0.2s ease all;
}
:global(.floatingplaceholder.csz_error) {
    border-color: var(--semperred);
    border-width: 3px;
    border-style:solid;
}
.bottomcontainer {
    grid-area: bc;
}
.seehoweasycontainer {
    grid-area: sc;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.shetitle {
    width: 100%;
    text-align: center;
    font-weight: 600;
    color: black;
    font-size: 3em;
    padding-top: 50px;
    padding-bottom: 15px;
}
.shetext {
    width: 100%;
    text-align: center;
    font-size: 1em;
    line-height: 1.5em;
    color: var(--blueslate);
    padding-left: 20px;
    padding-right: 20px;
}
.shebuttonholder {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.shebuttonholder button {
    padding: 10px 30px;
    border: solid 1px;
    border-radius: 5px;
    cursor: pointer;
    border-color: var(--semperred);
    color: white;
    background-color: var(--semperred);
    width: 200px;
    transition: all 0.25s linear;
}
.asseenon {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    /* border-top: 1px solid; */
    border-color: #dbdbdb;
}
.asologocontainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 50px;
    padding-bottom: 80px;
    border-bottom: solid 1px;
    border-color: #D2D7D9;;
}

.footercontainer {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    grid-area: fc;
}    


.mobileholder {
    grid-area: mh;
    text-align: center;
    padding-top: 50px;
    font-size: 2em;
    font-weight: bold;
    display: none;
}

@media (max-device-width: 1200px), (max-width: 1199px) {
    .navlinkscontainer {
        display: none;
    }
}
@media (max-device-width: 1024px), (max-width: 1023px) {
    .navcontainer {
        display: none;
    }
    .navmobilecontainer {
        width: 100%;
        max-width: 100vw;
        /* background-color: #2c313d; */
        min-height: 72px;
        display: flex;
        align-items:flex-start;
        justify-content: space-between;
        padding-top: 30px;
        position: relative;
    }
    .navmobilecontainerprogressmobile {
        border-bottom: 1px solid black;
    }
    .hamburgermenucontainer {
        max-width: 100vw;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-left: -100px;
    }
    .mobilemenucontainer {
        display: flex;
        flex-direction: column;
        min-height: 200px;
        align-items: flex-end;
        min-width: 200px;
        /* width: 100vw; */
    }
    :global(.closedmenu) {
        display: none !important;
    }
    .hamburgermenu {
        width: 30px;
        height: 45px;
        position: relative;
        margin-right: 20px;
        /* margin: 50px auto; */
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: .5s ease-in-out;
        -moz-transition: .5s ease-in-out;
        -o-transition: .5s ease-in-out;
        transition: .5s ease-in-out;
        cursor: pointer;        
    }
    .hamburgermenu span{
        display: block;
        position: absolute;
        height: 4px;
        width: 100%;
        background: white;
        border-radius: 3px;
        opacity: 1;
        left: 0;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
    }
    .hamburgermenu span:nth-child(1) {
        top: 0px;
    }

    .hamburgermenu span:nth-child(2),.hamburgermenu span:nth-child(3) {
        top: 10px;
    }

    .hamburgermenu span:nth-child(4) {
        top: 20px;
    }

    :global(.hamburgermenu.open span:nth-child(1)) {
        top: 10px;
        width: 0%;
        left: 50%;
    }

    :global(.hamburgermenu.open span:nth-child(2)) {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    :global(.hamburgermenu.open span:nth-child(3)) {
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        transform: rotate(-45deg);
    }

    :global(.hamburgermenu.open span:nth-child(4)) {
        top: 18px;
        width: 0%;
        left: 50%;
    }

    .numbercontainer {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        width: 150px;
        color: white;
        margin-right: 0;
    }
    .navlink {
        margin-right: 25px;
        text-align: right;
        margin-bottom: 30px;
    }
    .navlink:first-of-type {
        margin-top: 20px;
    }
    .phoneiconcontainer {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .phoneiconcontainer img {
        width:  1em;
        height: 1em;
        filter: invert(1);
    }
    .phonenumber {
        font-size: 1em;
        /* margin-left: 10px; */
    }
    .phonenumber a {
        text-decoration: none;
        color: white;
    }
    .numbercontainer {
        width: auto;
        /* margin-right: 40px; */
    }
    .phonenumber {
        font-size: 0.75em;
        margin-left: 0px;
    }

    .mobileapplynowbuttoncontainer {
        /* width: 100%;
        height: 32px; */
        width: 100%;
        /* height: 64px; */
        margin-top: 40px;
        margin-bottom: 40px;
        margin-right: 25px;
        display: flex;
        justify-content: flex-end;
    }
    .mobileapplynowbuttoncontainer a {
        width: 100%;
        text-decoration: none;
        text-align: center;
        background-color: var(--semperred);
        border: none;
        color: white;
        font-weight: 400;
        padding-bottom: 10px;
        padding-top: 10px;
        padding-left: 25px;
        padding-right: 25px;
        border-radius: 5px;
        cursor:pointer;
    }

    .logocontainer {
        /* display: flex; */
        /* justify-content: center; */
        /* width: 100%; */
        margin-left: auto;
        margin-right: auto;
    }
    .topcontainer {
        grid-area: tc;
        background-image: url(/img/House_1_opacity.png);
        background-repeat:no-repeat;
        min-height: 740px;
        /* height: 154vw; */
        height: auto;
        width: 100%;
        /* background-position-x: 50%; */
        /* background-position-y: 10%; */
        background-position: left 50% top -30%;
        background-size: 400% 75%;
        background-size: cover;
        
    }
    .topcontainerprogressmobile {
        background-image: none;
    }
    .stepcontainer {
        width: 100%;
        height: auto;
        /* padding-left: 20px; */
        /* padding-right: 20px; */
        /* box-sizing: border; */
        margin-top: 20px;
    }
    .stepcontainerprogressmobile {
        margin-top: 0px;
    }
    .csztitlecontainer {
        width: 90%;
        text-align: center;
        font-weight:600;
        color: white;
        font-size: 2em;
        margin-top: 25px;
    }    

    .csztextcontainer, .cszconditionscontainer{
        font-weight: normal;
        font-size: 1em;
        color: var(--blueslate);
    }    
    .cszfieldcontainer {
        width: 100%;
    }
    .cszfieldcontainer input[type=text] {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        /* min-width: 150px; */
        /* max-width: 100%; */
    }
    .cszfieldcontainer button {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        margin: 0 auto;
        margin-top: 20px;
        padding: 0;
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        /* padding-left: 15px; */
        /* padding-right: 15px; */
    }
    .cszfieldcontainer {
        flex-direction: column;
        align-items: center;
        /* margin-bottom: 50px; */
        
    }
    .csztitlecontainer {
        margin-top: 15px;
        color: white !important;
        text-align: center !important;
        max-width: 300px;
        /* margin-left: -65px; */
        font-size: 1.75em !important;
        
    }
    /* .cszinputcontainer {
        min-width: 0;
        max-width: 90% !important;
        width: 90% !important;
        margin-left: auto;
        margin-right: auto;
    }
    .cszinputfieldcontainer {
        width: 90% !important;
        margin-left: auto;
        margin-right: auto;        
    } */
    .maincontainer {
        /* width: 100%; */
        /* max-width: 100vw; */
        width: 100vw;
        max-width: 100vw !important;
        min-width: 100vw !important;
        margin-left: none;
        margin-right: none;
        /* width: 100vw; */

        /* margin-left: auto; */
        /* margin-right: auto; */
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        /* display: grid; */
        /* grid-template-columns: repeat(1, 1fr); */
        /* grid-template-rows: auto; */
        /* grid-template-areas: "bc" */
                             /* "fc"; */
        /* gap: 20px; */

    }
    .maincontainerprogressmobile {
        background-color: white;
    }
    .footercontainer {
        margin-top: 50px;
    }
    .shetitle {
        font-size: 2em;
    }
    .asseenon {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        flex-direction: column;
        border-top: 1px solid;
        border-color: #dbdbdb;
    }
    .asologocontainer {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        padding-top: 50px;
        padding-bottom: 80px;
    }
    .asoimagecontainer {
        width: 75px;
        padding-left: 20px;
        padding-right: 20px;
    }
    .asoimagecontainer img {
        width: 100%;
    }


}

</style>